import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();
  const [isHidden, setIsHidden] = useState(false);
  const [isUnderlined, setIsUnderlined] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSubMenu, setActiveSubMenu] = useState(null); // 서브메뉴 상태

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleSubMenu = (menu) => () => {
    setActiveSubMenu(activeSubMenu === menu ? null : menu); // 서브메뉴 열림/닫힘
  };

  const handleScroll = () => {
    const newScrollY = window.scrollY;
    setScrollY(newScrollY);
    setIsHidden(newScrollY > 0 && newScrollY <= 350);
  };

  const handleSubMenuClick =
    (path, category = null) =>
    (e) => {
      e.stopPropagation();
      if (category) {
        // category가 있을 경우 /board/category로 이동
        navigate(`/board/${category}`);
      } else if (path) {
        navigate(path);
      }
      window.scrollTo(0, 0);
      setIsMenuOpen(false);
    };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header
      id="header"
      className={`${isHidden ? 'hidden' : 'visible'} ${scrollY > 0 && isUnderlined ? 'underline' : ''}`}
    >
      <div className="header-box">
        <div className="header-left-box">
          <div className="main-logo" onClick={handleSubMenuClick('/')}></div>
        </div>
        <div className="header-right-box">
          <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
            <span className={`bar ${isMenuOpen ? 'rotate' : ''}`}></span>
            <span className={`bar ${isMenuOpen ? 'rotate' : ''}`}></span>
            <span className={`bar ${isMenuOpen ? 'rotate' : ''}`}></span>
          </div>
          <ul>
            <li
              onMouseEnter={() => scrollY > 0 && setIsUnderlined(true)}
              onMouseLeave={() => setIsUnderlined(false)}
              onClick={handleSubMenuClick('/about/intro')}
            >
              ABOUT
              {/* <ul className="submenu">
                <li onClick={handleSubMenuClick('/about/intro')}>회사소개</li>
                <li onClick={handleSubMenuClick('/about/history')}>연혁</li>
                <li onClick={handleSubMenuClick('/about/directions')}>주소</li>
              </ul> */}
            </li>
            <li
              onMouseEnter={() => scrollY > 0 && setIsUnderlined(true)}
              onMouseLeave={() => setIsUnderlined(false)}
              onClick={handleSubMenuClick(null, 'games')}
            >
              GAMES
            </li>
            <li onClick={handleSubMenuClick(null, 'journal')}>JOURNAL</li>
            <li onClick={handleSubMenuClick(null, 'news')}>NEWS</li>
            <li onClick={handleSubMenuClick(null, 'contact_us')}>CONTACT US</li>
          </ul>
        </div>
      </div>

      {isMenuOpen && (
        <div className="mobile-header">
          <div className="overlay" onClick={toggleMenu}></div>
          <div className="mobile-main-title">PLASSION</div>
          <ul className="mobile-sub-total">
            <li onClick={handleSubMenuClick('/about/intro')}>
              ABOUT
              {/* <span className={`icon ${activeSubMenu === 'about' ? 'arrow-up' : 'arrow-down'}`}></span> */}
              {/* {activeSubMenu === 'about' && (
                <ul className="mobile-submenu">
                  <li onClick={handleSubMenuClick('/about/intro')}>회사소개</li>
                  <li onClick={handleSubMenuClick('/about/history')}>연혁</li>
                  <li onClick={handleSubMenuClick('/about/directions')}>오시는 길</li>
                </ul>
              )} */}
            </li>
            <li onClick={handleSubMenuClick(null, 'games')}>
              GAMES
              {/* <span className={`icon ${activeSubMenu === 'games' ? 'arrow-up' : 'arrow-down'}`}></span> */}
              {/* {activeSubMenu === 'games' && (
                <ul className="mobile-submenu">
                  <li onClick={handleSubMenuClick('/games/game1')}>GAME 1</li>
                  <li onClick={handleSubMenuClick('/games/game2')}>GAME 2</li>
                  <li onClick={handleSubMenuClick('/games/game3')}>GAME 3</li>
                </ul>
              )} */}
            </li>
            <li onClick={handleSubMenuClick(null, 'journal')}>JOURNAL</li>
            <li onClick={handleSubMenuClick(null, 'news')}>NEWS</li>
            <li onClick={handleSubMenuClick(null, 'contact_us')}>CONTACT US</li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;
